import { useTranslation } from "react-i18next";
import { ProfileAdd } from "iconsax-react";
import { Avatar } from "@/shared/ui";
import type { Locale } from "@/shared/utils";

export interface MemberItem {
  id: number;
  name: string;
  job_position_ru?: string | null;
  job_position_kk?: string | null;
}

interface Props {
  members: MemberItem[];
  canEdit: boolean;
  onOpenModal: () => void;
  locale: Locale;
  title?: string;
}

function getJobPosition(member: MemberItem, locale: Locale): string {
  if (locale === "kk" && member.job_position_kk) return member.job_position_kk;
  if (member.job_position_ru) return member.job_position_ru;
  return "";
}

export default function MembersSection({ members, canEdit, onOpenModal, locale, title }: Props) {
  const { t } = useTranslation("Common");

  return (
    <div className="p-7 radius-3xl surface-base-fill">
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-body-bold-lg content-base-primary">{title ?? t("members.title")}</h3>
      </div>

      <div className="flex flex-wrap gap-4">
        {canEdit && (
          <div className="flex items-center gap-2 cursor-pointer" onClick={onOpenModal}>
            <div className="w-10 h-10 radius-full border border-dashed surface-component-stroke content-base-low flex items-center justify-center shrink-0">
              <ProfileAdd size={20} color="currentColor" />
            </div>
            <div className="flex flex-col min-w-0">
              <p className="text-label-sm content-base-low truncate">{t("members.addMember")}</p>
            </div>
          </div>
        )}
        {members.length === 0 && !canEdit ? (
          <p className="text-body-regular-md content-base-low">{t("members.empty")}</p>
        ) : (
          members.map((member) => {
            const position = getJobPosition(member, locale);
            return (
              <div key={member.id} className="flex items-center gap-2">
                <Avatar name={member.name} size={40} textClassName="text-label-sm" />
                <div className="flex flex-col min-w-0">
                  <p className="text-label-sm content-base-primary truncate">{member.name}</p>
                  {position && <span className="text-label-xs content-base-low truncate">{position}</span>}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
